'use strict';

var Field = require('./Field');

require('../../services/utils.service');

angular.module('dekky.forms.fields.uiTypeahead', ['ui.bootstrap'])
	.factory('UiTypeaheadField', function($q) {
		function uiTypeaheadFactory(name, options) {
			function UiTypeahead(name, options) {
				this.type = 'uiTypeahead';
				this.clearBtn = false;

				Field.apply(this, arguments);
			}

			UiTypeahead.prototype = Object.create(Field.prototype);
			UiTypeahead.prototype.link = function(template, scope) {
				scope.clear = function() {
					scope.model = undefined;
				};

				return $q.when(template);
			};

			return new UiTypeahead(name, options);
		}

		return uiTypeaheadFactory;
	});